import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { BIZDEV_NAV } from './nav';

const Pricing: React.FC = () => {
    const { api } = useInternalApi();
    const [tiers, setTiers] = useState<any[]>([]);
    const [total, setTotal] = useState(0);
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Pricing & Packaging - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('bizdev-api/pricing/').then(r => {
            if (r.data?.status === 'success') {
                setTiers(r.data.data.tiers || []);
                setTotal(r.data.data.total_accounts || 0);
                setNote(r.data.data.note || '');
            }
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="business_development" subNav={BIZDEV_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faTags} className="me-2 text-primary" />Pricing & Packaging</h2>
            <p className="text-muted mb-4">How accounts are actually distributed across the subscription tiers</p>

            <div className="alert alert-secondary small"><FontAwesomeIcon icon={faInfoCircle} className="me-2" />{note}</div>

            {loading ? (
                <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
            ) : (
                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white d-flex justify-content-between">
                        <strong>Tier distribution</strong>
                        <span className="text-muted small">{total} subscribed account(s)</span>
                    </div>
                    <div className="card-body p-0">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light"><tr><th>Tier</th><th>Dashboards included</th><th>Accounts</th><th style={{ width: '40%' }}>Share</th></tr></thead>
                            <tbody>
                                {tiers.map(t => (
                                    <tr key={t.tier}>
                                        <td><strong>{t.label}</strong></td>
                                        <td>{t.max_dashboards}</td>
                                        <td>{t.accounts}</td>
                                        <td>
                                            <div className="progress" style={{ height: 8 }}>
                                                <div className="progress-bar bg-primary" style={{ width: `${t.share_pct}%` }} />
                                            </div>
                                            <span className="small text-muted">{t.share_pct}%</span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </InternalShell>
    );
};

export default Pricing;
